var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('Header',{staticClass:"banner__header"}),(this.$layout.current === 'phone')?_c('SliderMobile'):_c('SliderDesktop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }